import { h } from '@stencil/core';
import { triggerTrackEvent } from 'utils/events';
import flightDetailModal from 'store/flightDetailModal';
import { i18n } from 'i18n';
import FlightTab from './FlightTab';

export default function FlightDetailModal({ show }: { show: boolean }) {
  const onClose = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `flight_detail_close`,
    });
    flightDetailModal.isOpen = false;
  };

  return show ? (
    <div id="flight-detail-modal" role="presentation" class="eva-3-modal -show-modal fullscreen-modal">
      <div class="modal-header" role="presentation">
        <i class="eva-3-icon-cross  modal-close -eva-3-mr-md" role="button" tabindex="0" aria-label="Close modal" onClick={() => onClose()} />
      </div>
      <div class="modal-content" role="presentation">
        <div class="eva-3-tabs -no-stroke">
          <div class="tabs-nav-corners-container">
            <div class="tabs-nav-container">
              <ul class="tabs-nav">
                {flightDetailModal.departureFlights && (
                  <li
                    role="presentation"
                    class={{ 'tabs-nav-item -subtitle': true, '-active': flightDetailModal.activeTab === 'DEPARTURE' }}
                    onClick={() => (flightDetailModal.activeTab = 'DEPARTURE')}
                  >
                    <span class="tab-label -eva-3-uppercase">
                      <span class="eva-3-icon-airplane-going -eva-3-mr-xsm"></span>
                      {i18n.t.flightDetailModal.departure}
                    </span>
                    <span class="tab-label">{flightDetailModal.departureFlights.departureDate.date}</span>
                  </li>
                )}
                {flightDetailModal.returnFlights && (
                  <li
                    role="presentation"
                    class={{ 'tabs-nav-item -subtitle': true, '-active': flightDetailModal.activeTab === 'RETURN' }}
                    onClick={() => (flightDetailModal.activeTab = 'RETURN')}
                  >
                    <span class="tab-label -eva-3-uppercase">
                      <span class="eva-3-icon-airplane-return -eva-3-mr-xsm"></span>
                      {i18n.t.flightDetailModal.return}
                    </span>
                    <span class="tab-label">{flightDetailModal.returnFlights.departureDate.date}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div class="tabs-container">
            {flightDetailModal.departureFlights && (
              <div class={{ 'tab-content': true, '-active': flightDetailModal.activeTab === 'DEPARTURE' }}>
                <FlightTab flightSegment={flightDetailModal.departureFlights} />
              </div>
            )}
            {flightDetailModal.returnFlights && (
              <div class={{ 'tab-content': true, '-active': flightDetailModal.activeTab === 'RETURN' }}>
                <FlightTab flightSegment={flightDetailModal.returnFlights} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
